/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * CommunityGameBase
 * auto generated base class for the model CommunityGameModel.
 */
export const CommunityGameModelBase = ModelBase.named('CommunityGame')
  .props({
    __typename: types.optional(types.literal('CommunityGame'), 'CommunityGame'),
    actionTime: types.union(types.undefined, types.integer),
    blinds: types.union(types.undefined, types.array(types.integer)),
    channelName: types.union(types.undefined, types.string),
    hasLeftGame: types.union(types.undefined, types.boolean),
    isFull: types.union(types.undefined, types.boolean),
    isLocked: types.union(types.undefined, types.boolean),
    name: types.union(types.undefined, types.string),
    seats: types.union(types.undefined, types.array(types.integer))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CommunityGameModelSelector extends QueryBuilder {
  get actionTime() {
    return this.__attr('actionTime')
  }
  get blinds() {
    return this.__attr('blinds')
  }
  get channelName() {
    return this.__attr('channelName')
  }
  get hasLeftGame() {
    return this.__attr('hasLeftGame')
  }
  get isFull() {
    return this.__attr('isFull')
  }
  get isLocked() {
    return this.__attr('isLocked')
  }
  get name() {
    return this.__attr('name')
  }
  get seats() {
    return this.__attr('seats')
  }
}
export function selectFromCommunityGame() {
  return new CommunityGameModelSelector()
}

export const communityGameModelPrimitives =
  selectFromCommunityGame().actionTime.blinds.channelName.hasLeftGame.isFull.isLocked.name.seats
